import React from "react"
import { MDXProvider } from "@mdx-js/react"
import CssBaseline from "@material-ui/core/CssBaseline"
import Grid from "@material-ui/core/Grid"
import MdxCustomizer from "./mdx-customizer"
import RightBar from "./sidebars/right-bar"
import Header from "./header"
import Footer from "./footer"
import styled from "@emotion/styled"
import { makeStyles } from "@material-ui/core"
const shortcodes = {}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  link: {
    marginLeft: theme.spacing(2),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  right: {},
  title: {},
}))

const InternalWrapper = styled.div`
  padding-left: 48px;
  padding-right: 48px;
  min-height: calc(100vh - 168px);
`
const GeneralWrapper = styled.div`
  background-color: #f8f8f8;
`

const Layout = ({ children }) => {
  const classes = useStyles
  return (
    <>
      <CssBaseline />
      <Header />
      <GeneralWrapper>
        <Grid container spacing={1} alignItems="stretch">
          <Grid item xs={9}>
            <InternalWrapper>
              <MdxCustomizer>
                <MDXProvider components={shortcodes}>{children}</MDXProvider>
              </MdxCustomizer>
            </InternalWrapper>
          </Grid>
          <Grid item xs={3} className={classes.right}>
            <RightBar />
          </Grid>
        </Grid>
      </GeneralWrapper>
      <Footer />
    </>
  )
}

export default Layout
